import script from "./DeptTreeList.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeptTreeList.vue?vue&type=script&setup=true&lang=ts"

import "./DeptTreeList.vue?vue&type=style&index=0&id=38f116c4&scoped=true&lang=css"

import exportComponent from "K:\\VoionContaract\\voion.contaract.clients\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38f116c4"]])

export default __exports__